import React, {memo} from 'react';
import {AdminForm} from '../../Component/Form/AdminForm';
import {AdminCrudPage} from '../../Component/Page/AdminCrudPage';

export const UserAdminAddScreen: React.FC = memo(() => (
  <AdminCrudPage entityType="user" action="Add">
    <AdminForm redirectUrl="/admin/user" mutationName="addUser"/>
  </AdminCrudPage>
));
